import { LocaleUtility } from '@inter-ikea-kompis/utilities';
import ServiceFetch from '../../../utilities/ServiceFetch.js';
/**
 * This class is used for fetching authentication data.
 */
export default class MvEcomAuthenticationService {
    /**
     * @param options Options.
     * @param options.endpoint Endpoint to fetch aut status.
     * @param options.locale Locale to fetch cookie.
     */
    constructor(options) {
        this.endpoint = options.endpoint;
        this.locale = options.locale;
    }
    /**
     * Authenticates and returns token.
     *
     * @returns Promise.
     */
    async getToken() {
        const userAuthState = await this.getAuthenticationState();
        if (!userAuthState.isAuthenticated || !userAuthState.customerId) {
            return null;
        }
        const token = this.getUserCookie();
        if (token) {
            return {
                value: token,
                customerId: userAuthState.customerId
            };
        }
        return null;
    }
    async getAuthenticationState() {
        const response = await ServiceFetch.json(this.endpoint);
        return response;
    }
    getUserCookie() {
        const countryCode = LocaleUtility.getCountryAndLanguage(this.locale).country?.toLowerCase();
        const cookieName = `auth0-session-${countryCode}`;
        return document.cookie.match('(^|;)\\s*' + cookieName + '\\s*=\\s*([^;]+)')?.pop();
    }
}
//# sourceMappingURL=MvEcomAuthenticationService.js.map